export interface IVariable {
    variavelNo:number;
    valor: string;
}
